var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EstadoProyectoService } from '../../../services/estadoProyectoService.ts';
import { showConfirmDialog } from '../../utils/confirmDialog';
export var CatalogoEstadosProyectosMixin = {
    data: function () {
        return {
            estadosProyectos: [],
            showModal: false,
            modoEdicion: false,
            cargando: false,
            guardando: false,
            formulario: {
                idEstadoProyecto: null,
                nombre: '',
            },
        };
    },
    mounted: function () {
        this.cargarEstadosProyectos();
    },
    methods: {
        cargarEstadosProyectos: function () {
            return __awaiter(this, void 0, Promise, function () {
                var _a, error_1, axiosError;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            this.cargando = true;
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, 4, 5]);
                            _a = this;
                            return [4 /*yield*/, EstadoProyectoService.getAll()];
                        case 2:
                            _a.estadosProyectos = _d.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _d.sent();
                            console.error('Error al cargar estados de proyectos:', error_1);
                            axiosError = error_1;
                            if (axiosError.code === 'ECONNREFUSED' || ((_b = axiosError.message) === null || _b === void 0 ? void 0 : _b.includes('No es posible conectar'))) {
                                this.$toast.error('No se puede conectar con el servidor. Verifique que el backend esté ejecutándose.');
                            }
                            else if (((_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status) === 404) {
                                this.$toast.error('El endpoint de estados de proyectos no está disponible.');
                            }
                            else {
                                this.$toast.error('Error al cargar los estados de proyectos');
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            this.cargando = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        editarEstado: function (estado) {
            this.modoEdicion = true;
            this.formulario = __assign({}, estado);
            this.$bvModal.show('modal-estado-proyecto');
        },
        guardarEstado: function () {
            return __awaiter(this, void 0, Promise, function () {
                var updatedEstado, index, newEstado, error_2, axiosError;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.guardando = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            if (!this.modoEdicion) return [3 /*break*/, 3];
                            return [4 /*yield*/, EstadoProyectoService.update(this.formulario.idEstadoProyecto, this.formulario)];
                        case 2:
                            updatedEstado = _a.sent();
                            index = this.estadosProyectos.findIndex(function (e) { return e.idEstadoProyecto === _this.formulario.idEstadoProyecto; });
                            if (index !== -1) {
                                this.estadosProyectos[index] = updatedEstado;
                            }
                            this.$toast.success('Estado de proyecto actualizado correctamente');
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, EstadoProyectoService.create(this.formulario)];
                        case 4:
                            newEstado = _a.sent();
                            this.estadosProyectos.push(newEstado);
                            this.$toast.success('Estado de proyecto creado correctamente');
                            _a.label = 5;
                        case 5:
                            this.limpiarFormulario();
                            this.$bvModal.hide('modal-estado-proyecto');
                            return [3 /*break*/, 8];
                        case 6:
                            error_2 = _a.sent();
                            console.error('Error al guardar estado de proyecto:', error_2);
                            axiosError = error_2;
                            if (axiosError.response && axiosError.response.status === 400) {
                                this.$toast.error('Datos inválidos. Verifique la información ingresada.');
                            }
                            else {
                                this.$toast.error('Error al guardar el estado de proyecto');
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            this.guardando = false;
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        eliminarEstado: function (id) {
            return __awaiter(this, void 0, Promise, function () {
                var estado, nombreEstado, confirmed, result, error_3, error_4, axiosError;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            estado = this.estadosProyectos.find(function (e) { return e.idEstadoProyecto === id; });
                            nombreEstado = (estado === null || estado === void 0 ? void 0 : estado.nombre) || 'este estado de proyecto';
                            confirmed = false;
                            if (!(this.$swal && typeof this.$swal === 'function')) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, showConfirmDialog(this.$swal, {
                                    title: '¿Eliminar estado de proyecto?',
                                    itemName: nombreEstado,
                                    itemType: 'estado de proyecto'
                                })];
                        case 2:
                            result = _a.sent();
                            confirmed = result.value;
                            return [3 /*break*/, 4];
                        case 3:
                            error_3 = _a.sent();
                            console.warn('Error con SweetAlert2, usando confirm nativo:', error_3);
                            confirmed = confirm("\u00BFEst\u00E1 seguro de que desea eliminar \"".concat(nombreEstado, "\"?"));
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            confirmed = confirm("\u00BFEst\u00E1 seguro de que desea eliminar \"".concat(nombreEstado, "\"?"));
                            _a.label = 6;
                        case 6:
                            if (!confirmed) return [3 /*break*/, 10];
                            _a.label = 7;
                        case 7:
                            _a.trys.push([7, 9, , 10]);
                            return [4 /*yield*/, EstadoProyectoService.delete(id)];
                        case 8:
                            _a.sent();
                            this.estadosProyectos = this.estadosProyectos.filter(function (e) { return e.idEstadoProyecto !== id; });
                            this.$toast.success("Estado de proyecto \"".concat(nombreEstado, "\" eliminado correctamente"));
                            return [3 /*break*/, 10];
                        case 9:
                            error_4 = _a.sent();
                            console.error('Error al eliminar estado de proyecto:', error_4);
                            axiosError = error_4;
                            if (axiosError.response && axiosError.response.status === 404) {
                                this.$toast.error('El estado de proyecto no existe');
                            }
                            else if (axiosError.response && axiosError.response.status === 409) {
                                this.$toast.error('No se puede eliminar el estado de proyecto porque está siendo utilizado');
                            }
                            else {
                                this.$toast.error('Error al eliminar el estado de proyecto');
                            }
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        },
        limpiarFormulario: function () {
            this.formulario = {
                idEstadoProyecto: null,
                nombre: '',
            };
            this.modoEdicion = false;
        },
    },
};
